import * as Types from '../../../../@graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type StoriesIncutSelectionQueryVariables = Types.Exact<{
  storyId: Types.Scalars['UUID'];
  status: Types.IncutStatus;
  limit?: Types.Maybe<Types.Scalars['Int']>;
  first?: Types.Maybe<Types.Scalars['Int']>;
  after?: Types.Maybe<Types.Scalars['String']>;
  last?: Types.Maybe<Types.Scalars['Int']>;
  before?: Types.Maybe<Types.Scalars['String']>;
}>;


export type StoriesIncutSelectionQuery = (
  { __typename?: 'Query' }
  & { storiesIncutSelection?: Types.Maybe<(
    { __typename?: 'StoriesIncutConnection' }
    & Pick<Types.StoriesIncutConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<Types.PageInfo, 'hasNextPage' | 'endCursor'>
    ), edges: Array<Types.Maybe<(
      { __typename?: 'StoriesIncutEdge' }
      & Pick<Types.StoriesIncutEdge, 'cursor'>
      & { node?: Types.Maybe<(
        { __typename?: 'StoriesIncutBlock' }
        & StoriesIncutBlockFragmentFragment
      )> }
    )>> }
  )> }
);

export type UpdateStoriesIncutSelectionMutationVariables = Types.Exact<{
  data: Types.UpdateStoriesIncutSelectionInput;
}>;


export type UpdateStoriesIncutSelectionMutation = (
  { __typename?: 'Mutation' }
  & { updateStoriesIncutSelection?: Types.Maybe<(
    { __typename?: 'UpdateStoriesIncutSelectionPayload' }
    & Pick<Types.UpdateStoriesIncutSelectionPayload, 'status'>
    & { blocks?: Types.Maybe<Array<(
      { __typename?: 'StoriesIncutBlock' }
      & StoriesIncutBlockFragmentFragment
    )>> }
  )> }
);

export type SaveStoriesIncutBlockMutationVariables = Types.Exact<{
  data: Types.SaveStoriesIncutBlockInput;
}>;


export type SaveStoriesIncutBlockMutation = (
  { __typename?: 'Mutation' }
  & { saveStoriesIncutBlock?: Types.Maybe<(
    { __typename?: 'SaveStoriesIncutBlockPayload' }
    & { block?: Types.Maybe<(
      { __typename?: 'StoriesIncutBlock' }
      & StoriesIncutBlockFragmentFragment
    )> }
  )> }
);

export type StoriesIncutBlockFragmentFragment = (
  { __typename?: 'StoriesIncutBlock' }
  & Pick<Types.StoriesIncutBlock, 'id' | 'uid' | 'position' | 'title' | 'incutType' | 'url' | 'clickCount' | 'createdAt' | 'updatedAt'>
  & { figureVersion?: Types.Maybe<(
    { __typename?: 'FigureVersion' }
    & Pick<Types.FigureVersion, 'id' | 'uid' | 'hasWatermark' | 'hasDiagonalWatermark'>
    & { primaryProcessedImage?: Types.Maybe<(
      { __typename?: 'Image' }
      & Pick<Types.Image, 'url'>
    )>, crop: (
      { __typename?: 'Crop' }
      & Pick<Types.Crop, 'left' | 'top' | 'width' | 'height'>
    ), figure: (
      { __typename?: 'Figure' }
      & Pick<Types.Figure, 'id' | 'src' | 'uid'>
      & { cropperPreview: (
        { __typename?: 'Image' }
        & Pick<Types.Image, 'url'>
      ) }
    ) }
  )> }
);

export type PublicationByUrlForBannerQueryVariables = Types.Exact<{
  url: Types.Scalars['String'];
}>;


export type PublicationByUrlForBannerQuery = (
  { __typename?: 'Query' }
  & { publicationByUrl?: Types.Maybe<(
    { __typename: 'ExternalPublication' }
    & Pick<Types.ExternalPublication, 'url' | 'title' | 'subtitle' | 'announcingImageUrl'>
  ) | (
    { __typename: 'Publication' }
    & Pick<Types.Publication, 'uid' | 'title'>
    & { announceImage: (
      { __typename?: 'AnnounceImage' }
      & Pick<Types.AnnounceImage, 'id'>
      & { figureVersion?: Types.Maybe<(
        { __typename?: 'FigureVersion' }
        & FigureVersionFragmentFragment
      )> }
    ) }
  )> }
);

export type FigureVersionFragmentFragment = (
  { __typename?: 'FigureVersion' }
  & Pick<Types.FigureVersion, 'id' | 'uid' | 'hasWatermark' | 'hasDiagonalWatermark'>
  & { primaryProcessedImage?: Types.Maybe<(
    { __typename?: 'Image' }
    & Pick<Types.Image, 'url'>
  )>, crop: (
    { __typename?: 'Crop' }
    & Pick<Types.Crop, 'left' | 'top' | 'width' | 'height'>
  ), figure: (
    { __typename?: 'Figure' }
    & Pick<Types.Figure, 'id' | 'src' | 'uid'>
    & { cropperPreview: (
      { __typename?: 'Image' }
      & Pick<Types.Image, 'url'>
    ) }
  ) }
);

export const StoriesIncutBlockFragmentFragmentDoc = gql`
    fragment StoriesIncutBlockFragment on StoriesIncutBlock {
  id
  uid
  position
  title
  incutType
  url
  clickCount
  createdAt
  updatedAt
  figureVersion {
    id
    uid
    hasWatermark
    hasDiagonalWatermark
    primaryProcessedImage {
      url
    }
    crop {
      left
      top
      width
      height
    }
    figure {
      id
      src
      uid
      cropperPreview {
        url
      }
    }
  }
}
    `;
export const FigureVersionFragmentFragmentDoc = gql`
    fragment FigureVersionFragment on FigureVersion {
  id
  uid
  hasWatermark
  hasDiagonalWatermark
  primaryProcessedImage {
    url
  }
  crop {
    left
    top
    width
    height
  }
  figure {
    id
    src
    uid
    cropperPreview {
      url
    }
  }
}
    `;
export const StoriesIncutSelectionDocument = gql`
    query storiesIncutSelection($storyId: UUID!, $status: IncutStatus!, $limit: Int, $first: Int, $after: String, $last: Int, $before: String) {
  storiesIncutSelection(
    filter: {storyId: $storyId, status: $status}
    limit: $limit
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        ...StoriesIncutBlockFragment
      }
    }
  }
}
    ${StoriesIncutBlockFragmentFragmentDoc}`;

/**
 * __useStoriesIncutSelectionQuery__
 *
 * To run a query within a React component, call `useStoriesIncutSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoriesIncutSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoriesIncutSelectionQuery({
 *   variables: {
 *      storyId: // value for 'storyId'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useStoriesIncutSelectionQuery(baseOptions: Apollo.QueryHookOptions<StoriesIncutSelectionQuery, StoriesIncutSelectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoriesIncutSelectionQuery, StoriesIncutSelectionQueryVariables>(StoriesIncutSelectionDocument, options);
      }
export function useStoriesIncutSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoriesIncutSelectionQuery, StoriesIncutSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoriesIncutSelectionQuery, StoriesIncutSelectionQueryVariables>(StoriesIncutSelectionDocument, options);
        }
export type StoriesIncutSelectionQueryHookResult = ReturnType<typeof useStoriesIncutSelectionQuery>;
export type StoriesIncutSelectionLazyQueryHookResult = ReturnType<typeof useStoriesIncutSelectionLazyQuery>;
export type StoriesIncutSelectionQueryResult = Apollo.QueryResult<StoriesIncutSelectionQuery, StoriesIncutSelectionQueryVariables>;
export const UpdateStoriesIncutSelectionDocument = gql`
    mutation updateStoriesIncutSelection($data: UpdateStoriesIncutSelectionInput!) {
  updateStoriesIncutSelection(data: $data) {
    status
    blocks {
      ...StoriesIncutBlockFragment
    }
  }
}
    ${StoriesIncutBlockFragmentFragmentDoc}`;
export type UpdateStoriesIncutSelectionMutationFn = Apollo.MutationFunction<UpdateStoriesIncutSelectionMutation, UpdateStoriesIncutSelectionMutationVariables>;

/**
 * __useUpdateStoriesIncutSelectionMutation__
 *
 * To run a mutation, you first call `useUpdateStoriesIncutSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStoriesIncutSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStoriesIncutSelectionMutation, { data, loading, error }] = useUpdateStoriesIncutSelectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateStoriesIncutSelectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStoriesIncutSelectionMutation, UpdateStoriesIncutSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStoriesIncutSelectionMutation, UpdateStoriesIncutSelectionMutationVariables>(UpdateStoriesIncutSelectionDocument, options);
      }
export type UpdateStoriesIncutSelectionMutationHookResult = ReturnType<typeof useUpdateStoriesIncutSelectionMutation>;
export type UpdateStoriesIncutSelectionMutationResult = Apollo.MutationResult<UpdateStoriesIncutSelectionMutation>;
export type UpdateStoriesIncutSelectionMutationOptions = Apollo.BaseMutationOptions<UpdateStoriesIncutSelectionMutation, UpdateStoriesIncutSelectionMutationVariables>;
export const SaveStoriesIncutBlockDocument = gql`
    mutation saveStoriesIncutBlock($data: SaveStoriesIncutBlockInput!) {
  saveStoriesIncutBlock(data: $data) {
    block {
      ...StoriesIncutBlockFragment
    }
  }
}
    ${StoriesIncutBlockFragmentFragmentDoc}`;
export type SaveStoriesIncutBlockMutationFn = Apollo.MutationFunction<SaveStoriesIncutBlockMutation, SaveStoriesIncutBlockMutationVariables>;

/**
 * __useSaveStoriesIncutBlockMutation__
 *
 * To run a mutation, you first call `useSaveStoriesIncutBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveStoriesIncutBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveStoriesIncutBlockMutation, { data, loading, error }] = useSaveStoriesIncutBlockMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveStoriesIncutBlockMutation(baseOptions?: Apollo.MutationHookOptions<SaveStoriesIncutBlockMutation, SaveStoriesIncutBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveStoriesIncutBlockMutation, SaveStoriesIncutBlockMutationVariables>(SaveStoriesIncutBlockDocument, options);
      }
export type SaveStoriesIncutBlockMutationHookResult = ReturnType<typeof useSaveStoriesIncutBlockMutation>;
export type SaveStoriesIncutBlockMutationResult = Apollo.MutationResult<SaveStoriesIncutBlockMutation>;
export type SaveStoriesIncutBlockMutationOptions = Apollo.BaseMutationOptions<SaveStoriesIncutBlockMutation, SaveStoriesIncutBlockMutationVariables>;
export const PublicationByUrlForBannerDocument = gql`
    query publicationByUrlForBanner($url: String!) {
  publicationByUrl(url: $url) {
    __typename
    ... on Publication {
      uid
      title
      announceImage {
        id
        figureVersion {
          ...FigureVersionFragment
        }
      }
    }
    ... on ExternalPublication {
      url
      title
      subtitle
      announcingImageUrl
    }
  }
}
    ${FigureVersionFragmentFragmentDoc}`;

/**
 * __usePublicationByUrlForBannerQuery__
 *
 * To run a query within a React component, call `usePublicationByUrlForBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicationByUrlForBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicationByUrlForBannerQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function usePublicationByUrlForBannerQuery(baseOptions: Apollo.QueryHookOptions<PublicationByUrlForBannerQuery, PublicationByUrlForBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicationByUrlForBannerQuery, PublicationByUrlForBannerQueryVariables>(PublicationByUrlForBannerDocument, options);
      }
export function usePublicationByUrlForBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicationByUrlForBannerQuery, PublicationByUrlForBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicationByUrlForBannerQuery, PublicationByUrlForBannerQueryVariables>(PublicationByUrlForBannerDocument, options);
        }
export type PublicationByUrlForBannerQueryHookResult = ReturnType<typeof usePublicationByUrlForBannerQuery>;
export type PublicationByUrlForBannerLazyQueryHookResult = ReturnType<typeof usePublicationByUrlForBannerLazyQuery>;
export type PublicationByUrlForBannerQueryResult = Apollo.QueryResult<PublicationByUrlForBannerQuery, PublicationByUrlForBannerQueryVariables>;